// @flow

import * as React from 'react';
import { LoadingIndicator } from '@ansarada/ace-react';
import styles from './styles.scss';

const LoadingPlaceholder = () => {
  return (
    <div className={styles.container}>
      <div className={styles.backdrop} />
      <div className={styles.loadingWrap}>
        <LoadingIndicator />
      </div>
    </div>
  );
};

export default LoadingPlaceholder;
